import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { 
  FiMail, FiLock, FiUser, FiPhone, FiEye, FiEyeOff,
  FiArrowLeft, FiFacebook
} from "react-icons/fi";
import { FaApple } from "react-icons/fa";
import { BsShieldCheck } from "react-icons/bs";
import logo from "../Assests/bookinindia-logo-optimized.png";
import { FcGoogle } from "react-icons/fc";
import { auth } from "../firebase/firebase";
import { signInWithEmailAndPassword, signInAnonymously } from "firebase/auth";

// Admin credentials config
const ADMIN_ACCOUNTS = [
  {
    email: "admin@bookinindia.com",
    password: "Admin@123",
    role: "super_admin",
    name: "Super Admin"
  },
  {
    email: "myjourneycabs@gmail.com",
    password: "Admin@123",
    role: "admin",
    name: "Admin"
  }
];

const AuthScreen = () => {
  const [isSignIn, setIsSignIn] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    fullName: "",
    phone: ""
  });
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const toggleAuthMode = () => {
    setIsSignIn(!isSignIn);
    setShowPassword(false);
    setShowConfirmPassword(false);
    setError("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const inputEmail = (formData.email || "").trim().toLowerCase();
    const inputPassword = (formData.password || "").trim();

    // Check for admin / super admin login
    const matchedAdmin = ADMIN_ACCOUNTS.find(
      acc => acc.email.toLowerCase() === inputEmail && acc.password === inputPassword
    );

    if (matchedAdmin) {
      // Store admin session
      localStorage.setItem('adminLoggedIn', 'true');
      localStorage.setItem('adminEmail', matchedAdmin.email);
      localStorage.setItem('adminRole', matchedAdmin.role);
      localStorage.setItem('adminName', matchedAdmin.name);
      localStorage.setItem('adminLoginTime', new Date().toISOString());
      
      try {
        await signInWithEmailAndPassword(auth, matchedAdmin.email, matchedAdmin.password);
      } catch (authErr) {
        try {
          await signInAnonymously(auth);
        } catch (anonErr) {
          console.log("Auth session initialized");
        }
      }

      setLoading(false);
      navigate('/admin/dashboard');
      return;
    }

    // Regular user authentication (you can add your own logic here)
    if (isSignIn) {
      // Regular user login logic
      console.log("User login:", formData);
      // For demo, just navigate to home
      navigate('/');
    } else {
      // Regular user signup logic
      if (formData.password !== formData.confirmPassword) {
        setError("Passwords do not match");
        setLoading(false);
        return;
      }
      console.log("User signup:", formData);
      // For demo, just navigate to home
      navigate('/');
    }
    
    setLoading(false);
  };

  const handleGoogleSignIn = () => {
    console.log("Google sign in");
  };

  const handleFacebookSignIn = () => {
    console.log("Facebook sign in");
  };

  const handleAppleSignIn = () => {
    console.log("Apple sign in");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-red-50 flex items-center justify-center p-4 -mt-16">
      {/* Desktop View */}
      <div className="hidden md:block w-full max-w-6xl">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex">
          {/* Left Side - Branding/Illustration */}
          <div className="w-1/2 bg-gradient-to-br from-[#d60f0f] to-red-600 p-12 flex flex-col justify-between text-white">
            <div>
              <img src={logo} alt="Logo" className="h-28 w-auto mb-8 filter brightness-0 invert" />
              <h2 className="text-3xl font-bold mb-4">
                {isSignIn ? "Welcome Back!" : "Join Us Today!"}
              </h2>
              <p className="text-red-100 mb-8">
                {isSignIn 
                  ? "Sign in to continue your journey with us and book your rides seamlessly."
                  : "Create an account to start booking rides and enjoy exclusive benefits."}
              </p>
            </div>
            
            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <BsShieldCheck size={24} />
                </div>
                <div>
                  <h4 className="font-semibold">Safe & Secure</h4>
                  <p className="text-sm text-red-100">Your data is protected</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <FiUser size={24} />
                </div>
                <div>
                  <h4 className="font-semibold">24/7 Support</h4>
                  <p className="text-sm text-red-100">We're here to help</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Auth Form */}
          <div className="w-1/2 p-12">
            <div className="max-w-md mx-auto">
              {/* Error Message */}
              {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-sm text-red-600">{error}</p>
                </div>
              )}

              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                {isSignIn ? "Sign In" : "Create Account"}
              </h2>
              <p className="text-gray-600 mb-8">
                {isSignIn 
                  ? "Please enter your details to sign in" 
                  : "Fill in your details to get started"}
              </p>

              {/* Social Login Buttons */}
              <div className="flex gap-3 mb-6">
                <button
                  onClick={handleGoogleSignIn}
                  className="flex-1 flex items-center justify-center gap-2 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <FcGoogle size={20} className="text-red-500" />
                  <span className="text-sm font-medium text-gray-700">Google</span>
                </button>
                <button
                  onClick={handleFacebookSignIn}
                  className="flex-1 flex items-center justify-center gap-2 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <FiFacebook size={20} className="text-blue-600" />
                  <span className="text-sm font-medium text-gray-700">Facebook</span>
                </button>
                <button
                  onClick={handleAppleSignIn}
                  className="flex-1 flex items-center justify-center gap-2 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <FaApple size={20} className="text-gray-900" />
                  <span className="text-sm font-medium text-gray-700">Apple</span>
                </button>
              </div>

              <div className="relative mb-6">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300"></div>
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-gray-500">or continue with email</span>
                </div>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmit} className="space-y-4">
                {!isSignIn && (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Full Name
                      </label>
                      <div className="relative">
                        <FiUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                        <input
                          type="text"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleInputChange}
                          placeholder="John Doe"
                          className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                          required={!isSignIn}
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Phone Number
                      </label>
                      <div className="relative">
                        <FiPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="+91 98765 43210"
                          className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                          required={!isSignIn}
                        />
                      </div>
                    </div>
                  </>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email Address
                  </label>
                  <div className="relative">
                    <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="you@example.com"
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Password
                  </label>
                  <div className="relative">
                    <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      placeholder="••••••••"
                      className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                    </button>
                  </div>
                </div>

                {!isSignIn && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Confirm Password
                    </label>
                    <div className="relative">
                      <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        placeholder="••••••••"
                        className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                        required={!isSignIn}
                      />
                      <button
                        type="button"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      >
                        {showConfirmPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                      </button>
                    </div>
                  </div>
                )}

                {isSignIn && (
                  <div className="flex items-center justify-between">
                    <label className="flex items-center">
                      <input type="checkbox" className="rounded border-gray-300 text-[#d60f0f] focus:ring-[#d60f0f]" />
                      <span className="ml-2 text-sm text-gray-600">Remember me</span>
                    </label>
                    <Link to="/forgot-password" className="text-sm text-[#d60f0f] hover:underline">
                      Forgot password?
                    </Link>
                  </div>
                )}

                {!isSignIn && (
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="terms"
                      checked={agreedToTerms}
                      onChange={(e) => setAgreedToTerms(e.target.checked)}
                      className="rounded border-gray-300 text-[#d60f0f] focus:ring-[#d60f0f]"
                      required
                    />
                    <label htmlFor="terms" className="ml-2 text-sm text-gray-600">
                      I agree to the{" "}
                      <Link to="/terms" className="text-[#d60f0f] hover:underline">Terms of Service</Link>
                      {" "}and{" "}
                      <Link to="/privacy" className="text-[#d60f0f] hover:underline">Privacy Policy</Link>
                    </label>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#d60f0f] text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Processing...
                    </span>
                  ) : (
                    isSignIn ? "Sign In" : "Create Account"
                  )}
                </button>
              </form>

              <p className="text-center mt-6 text-gray-600">
                {isSignIn ? "Don't have an account?" : "Already have an account?"}
                <button
                  onClick={toggleAuthMode}
                  className="ml-2 text-[#d60f0f] font-semibold hover:underline focus:outline-none"
                >
                  {isSignIn ? "Sign Up" : "Sign In"}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View - App Style */}
      <div className="md:hidden w-full max-w-sm bg-white rounded-3xl shadow-2xl overflow-hidden -mt-20">
        {/* Header with back button */}
        <div className="bg-gradient-to-r from-[#d60f0f] to-red-600 p-6 relative">
          <button
            onClick={() => navigate(-1)}
            className="absolute top-6 left-4 text-white hover:opacity-80 transition-opacity"
          >
            <FiArrowLeft size={24} />
          </button>
          <div className="flex flex-col items-center mt-8">
            <img src={logo} alt="Logo" className="h-28 w-auto mb-4 filter brightness-0 invert" />
            <h1 className="text-2xl font-bold text-white mb-1">
              {isSignIn ? "Welcome Back!" : "Create Account"}
            </h1>
            <p className="text-red-100 text-sm text-center">
              {isSignIn 
                ? "Sign in to continue booking rides" 
                : "Sign up to start your journey with us"}
            </p>
          </div>
        </div>

        {/* Form Container */}
        <div className="p-6">
          {/* Error Message */}
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-xs text-red-600">{error}</p>
            </div>
          )}

          {/* Social Login Options */}
          <div className="flex justify-center gap-4 mb-6">
            <button
              onClick={handleGoogleSignIn}
              className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
            >
              <FcGoogle size={22} className="text-red-500" />
            </button>
            <button
              onClick={handleFacebookSignIn}
              className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
            >
              <FiFacebook size={22} className="text-blue-600" />
            </button>
            <button
              onClick={handleAppleSignIn}
              className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
            >
              <FaApple size={22} className="text-gray-900" />
            </button>
          </div>

          <div className="relative mb-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200"></div>
            </div>
            <div className="relative flex justify-center text-xs">
              <span className="px-2 bg-white text-gray-500">OR</span>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {!isSignIn && (
              <>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1 ml-1">
                    Full Name
                  </label>
                  <div className="relative">
                    <FiUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                      className="w-full pl-9 pr-3 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                      required={!isSignIn}
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1 ml-1">
                    Phone Number
                  </label>
                  <div className="relative">
                    <FiPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+91 98765 43210"
                      className="w-full pl-9 pr-3 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                      required={!isSignIn}
                    />
                  </div>
                </div>
              </>
            )}

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1 ml-1">
                Email Address
              </label>
              <div className="relative">
                <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  className="w-full pl-9 pr-3 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1 ml-1">
                Password
              </label>
              <div className="relative">
                <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter your password"
                  className="w-full pl-9 pr-10 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </div>

            {!isSignIn && (
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1 ml-1">
                  Confirm Password
                </label>
                <div className="relative">
                  <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    placeholder="Confirm your password"
                    className="w-full pl-9 pr-10 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#d60f0f] focus:border-transparent"
                    required={!isSignIn}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showConfirmPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                  </button>
                </div>
              </div>
            )}

            {isSignIn && (
              <div className="flex items-center justify-between">
                <label className="flex items-center">
                  <input type="checkbox" className="rounded border-gray-300 text-[#d60f0f] focus:ring-[#d60f0f]" />
                  <span className="ml-2 text-xs text-gray-600">Remember me</span>
                </label>
                <Link to="/forgot-password" className="text-xs text-[#d60f0f] font-medium">
                  Forgot password?
                </Link>
              </div>
            )}

            {!isSignIn && (
              <div className="flex items-start">
                <input
                  type="checkbox"
                  id="terms-mobile"
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                  className="mt-1 rounded border-gray-300 text-[#d60f0f] focus:ring-[#d60f0f]"
                  required
                />
                <label htmlFor="terms-mobile" className="ml-2 text-xs text-gray-600">
                  I agree to the{" "}
                  <Link to="/terms" className="text-[#d60f0f] font-medium">Terms</Link>
                  {" "}and{" "}
                  <Link to="/privacy" className="text-[#d60f0f] font-medium">Privacy Policy</Link>
                </label>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#d60f0f] text-white py-3.5 rounded-xl font-semibold hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 mt-2 disabled:opacity-50"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </span>
              ) : (
                isSignIn ? "Sign In" : "Create Account"
              )}
            </button>
          </form>

          {/* Toggle between Sign In/Sign Up */}
          <p className="text-center mt-6 text-sm text-gray-600">
            {isSignIn ? "New to our app?" : "Already have an account?"}
            <button
              onClick={toggleAuthMode}
              className="ml-2 text-[#d60f0f] font-semibold hover:underline focus:outline-none"
            >
              {isSignIn ? "Create Account" : "Sign In"}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthScreen;
